import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { WorkEditionsComponents } from "../react_isomorphic/work_editions";

window.ReactComponents = Object.assign(
  {},
  GlobalComponents,
  HeaderComponents,
  WorkEditionsComponents
);

window.ReactStores = Object.assign(
  {},
  GlobalStores,
  HeaderStores
);
